import Vue from 'vue'
export let bus = new Vue()
